// Scale iframes based on their width and height when both values are set
module.exports = {
    init: function()
    {
        const iframes = document.querySelectorAll("iframe");

        Array.from(iframes).forEach(iframe => {
            const width = iframe.getAttribute('width');
            const height = iframe.getAttribute('height');
            const isScalable = !iframe.classList.contains('no-scale') && !iframe.classList.contains('maglr-iframe');

            if (width && height && isScalable) {
                iframe.classList.add('iframe-scale');
                iframe.style.aspectRatio = `${width}/${height}`;
            }
        });
    }
}